  <!-- Zoom Popup Modal -->
  <!-- <div class="zoom-modal" *ngIf="zoomedFile" (click)="closeZoom()">
    <div class="zoom-content" (click)="$event.stopPropagation()">
      <canvas #zoomCanvas class="zoom-canvas"></canvas>
      <button class="close-btn" (click)="closeZoom()">✖</button>
    </div>
  </div> -->
  <!-- Zoom Popup Modal -->
  <div class="zoom-modal" *ngIf="zoomedFile" (click)="closeZoom()">
    <div class="zoom-content" (click)="$event.stopPropagation()">
      
      <canvas #zoomCanvas class="zoom-canvas"></canvas>
  
     
  
      <!-- Zoom & action controls -->
      <div class="zoom-controls">
 <!-- Page navigation controls -->
 <div class="page-navigation">
  <button class="nav-icon" (click)="goToPreviousPage()">
    <i class="fas fa-chevron-left"></i>
  </button>

  <input
    type="number"
    class="page-input zoom-pagination"
    [(ngModel)]="currentPage"
    (keydown.enter)="goToPage(currentPage)"
    [min]="1"
    [max]="totalPages"
  />

  <span class="page-label">/ {{ totalPages }}</span>

  <button class="nav-icon" (click)="goToNextPage()">
    <i class="fas fa-chevron-right"></i>
  </button>
</div>

        <button class="zoom-icon" (click)="zoomIn()">
          <i class="fas fa-search-plus"></i>
        </button>
        <button class="zoom-icon" (click)="zoomOut()">
          <i class="fas fa-search-minus"></i>
        </button>
        <button class="zoom-icon" (click)="rotateZoomedPage()">
          <i class="fas fa-sync-alt"></i>
        </button>
        <button class="zoom-icon" (click)="removePage(currentPage)">
          <i class="fas fa-trash-alt"></i>
        </button>
      </div>
  
      <button class="close-btn" (click)="closeZoom()">✖</button>
    </div>
  </div>
  

<ng-container *ngIf="fileType === 'application/pdf' && isMultiplefiles ">
  <div  class="file-container">
    <div #pdfViewer>
      <!-- For PDF files -->
      <div *ngIf="fileType === 'application/pdf'">
<div cdkDropList cdkDropListOrientation="mixed" class="list-order-list" (cdkDropListDropped)="drop($event)">
  @for (file of pFiles; track file) {
    <div class="list-order-box " cdkDrag>

      <div class="card" (mouseenter)="hoverIndex = $index" 
          (mouseleave)="hoverIndex = -1">
            <div class="card-body">
              <div class="container">
                <canvas #canvasElement class="pdf-canvas animate-row"
                [ngStyle]="{'transform': 'rotate(' + pFiles[$index]?.rotate + 'deg)'}"></canvas>
                <!-- <canvas #canvasElement class="pdf-canvas" ></canvas> -->
              </div>
            </div>
            <div class="file-page-wrapper">
              <div class="file-name">📄 {{ file.file.name.length > 20 ? (file.file.name | slice:0:20) + '...' : file.file.name }}</div>
              <div class="file-pages">📑 Pages: {{ getFilePages($index) }}</div>
            </div>
            <div class="hover-actions" *ngIf="hoverIndex === $index">
             
            <!-- Rotate -->
            <button class="action-btn hv-custom-tooltip" (click)="rotateFile($index)">
              <i class="fas fa-sync-alt"></i>
              <span class="hv-tooltip-text">Rotate</span>
            </button>
                     
            <button class="action-btn hv-custom-tooltip " 
            (click)="zoomFile($index)"
            >
                  <i class="fas fa-search-plus"></i>
                  <span class="hv-tooltip-text">Zoom</span>
            </button>
             <!-- Remove -->
            <button class="action-btn hv-custom-tooltip" (click)="removeFile($index)">
              <i class="fas fa-trash-alt"></i>
              <span class="hv-tooltip-text">Remove</span>
             </button>
            </div>
          </div>
          <div #overlayElement class="overlay"></div>
        </div>
  }
</div>
      </div>
    </div>
  </div>
</ng-container>
  <!-- For Image files -->
  <div *ngIf="fileType !== 'application/pdf'" class="pdf-page">
    <div class="card">
      <div class="card-body">
        <div class="container">
          <canvas #canvasElement class="pdf-canvas"></canvas>
        </div>
        <div class="file-name-display">{{ file.name }}</div>
        <div #overlayElement class="overlay"></div>
      </div>
    </div>
  </div>

<div #pdfViewer></div>
  <!-- For PDF files -->
  <div *ngIf="fileType === 'application/pdf' && !isMultiplefiles ">
    <div *ngFor="let pageNum of pageNumbers; let i = index" class="pdf-page">
      <div class="card">
        <div class="card-body">
          <div class="container">
            <canvas #canvasElement class="pdf-canvas"></canvas>
          </div>
        </div>
        <div class="file-name-display">{{ file.name }}</div>
      </div>
      <div #overlayElement class="overlay"></div>
    </div>
  </div>

